const firebase = require('firebase/app');
require('firebase/firestore');
  
  // Initialize Firebase
  const firebaseConfig = {
    apiKey: "AIzaSyBBrNdZ0qjFz8vdNhQ7ezb4fb4Okm_UWZY",
    authDomain: "guesswho-8e640.firebaseapp.com",
    databaseURL: "https://guesswho-8e640.firebaseio.com",
    projectId: "guesswho-8e640",
    storageBucket: "guesswho-8e640.appspot.com",
    messagingSenderId: "569622482503",
    appId: "1:569622482503:web:b9e7132c37816fcd26eb62",
    measurementId: "G-Y5BED5DPB3"
  }
  const app = firebase.initializeApp(firebaseConfig);

  export default app.firestore();